module.exports = __webpack_public_path__ + "img/footer_background.b5c5626f.jpg";